import { IButtonStyles } from '@fluentui/react';
import { IKeytipProps } from '@fluentui/react/lib/Keytip';
import { IStyle } from '@fluentui/react/lib/Styling';
import { IBaseProps } from '@fluentui/react/lib/Utilities';

import { AppControlBaseProps, ContextMenuMap } from '@1js/acui-common';

import { AppGalleryButtonOnExecuteParameter } from './AppGalleryButtonOnExecuteParameter';

export const galleryButtonAutomationTypeSuffix = 'GalleryButton';

// Jeremy's work on Gallery Button will be adding more onto IGalleryButtonProps
export interface AppGalleryButtonProps extends IBaseProps, AppControlBaseProps {
  type: 'AppGalleryButtonProps';

  /**
   * Index of the Gallery Button in the galleryButtons prop. Index will be
   * given to gallery buttons if not passed.
   * @defaultvalue [Derived from index in galleryButtons]
   */
  index?: number;

  /**
   * Optional accessibility label (aria-label) attribute that will be stamped on to the element.
   * If none is specified, the aria-label attribute will contain the item name.
   * @defaultvalue undefined
   */
  ariaLabel?: string;

  /**
   * Optional title for displaying text when hovering over an item.
   * @defaultvalue [Value of name prop]
   */
  title?: string;

  /**
   * Optional, whether the gallery button currently selected
   * @defaultvalue false
   */
  selected?: boolean;

  /**
   * The on execute handler for the gallery button.
   */
  onExecute?: (parameter: AppGalleryButtonOnExecuteParameter<AppGalleryButtonProps>) => void;

  /**
   * Optional, the on focus handler for the gallery button.
   */
  onFocus?: (galleryButton?: AppGalleryButtonProps) => void;

  /**
   * Optional, the on Blur handler for the gallery button.
   */
  onBlur?: (galleryButton?: AppGalleryButtonProps) => void;

  /**
   * The button style to be applied.
   */
  style?: IButtonStyles;

  /**
   * The role of this galleryButton
   */
  role?: string;

  /**
   * Should the gallery button focus when hovered?
   * @defaultvalue false
   */
  focusOnHover?: boolean;

  /**
   * Provide automation type information about the gallery button.
   */
  automationType?: string;

  /**
   * Provide an optional unique id that can be used to find the element (automation, callout target, et al)
   */
  uniqueId?: string;

  /**
   * Optional Keytip for this GalleryButton
   */
  keytipProps?: IKeytipProps;

  /**
   * String displayed on the gallery button
   */
  label?: string;

  /**
   * Optional key for gallery button when rendered in an array
   */
  key?: string;

  /**
   * List of IDs of the context menus we will be using for this control. We don't use just a string in case different parts of a control
   * need different menus.
   */
  contextMenuMap?: ContextMenuMap;
}

export interface GalleryListLevelInfo {
  textAtLevel: string;
  styleAtLevel: IStyle;
}
